import React from "react";
import { isArray } from "lodash";

import { getAssociatedIds } from "../../helpers";
import { CESAR_LOYALTY } from "@constants/index";

export function useArchiveIds(
    oneShop: boolean,
    shopsFidelityData: ShopsFidelityData,
    archivedFidelityFranchise: FidelityDataTable
) {
    const dataAssociate = React.useMemo(
        () => (!oneShop ? getAssociatedIds(shopsFidelityData) : []),
        [oneShop, shopsFidelityData]
    );

    const dataArchive = React.useMemo(() => {
        if (!oneShop) return getAssociatedIds(shopsFidelityData);

        const ids = new Set<string>();
        const franchiseData =
            archivedFidelityFranchise?.othersData?.archivedFranchise?.data;

        if (franchiseData) {
            for (const element of franchiseData) {
                const archivedAtZero =
                    isArray(element.isArchived) &&
                    element.isArchived.find(
                        // eslint-disable-next-line no-loop-func
                        (el: FidelityArchiveEntry) => el.shopId === "0"
                    )?.status === true;

                if (
                    archivedAtZero ||
                    element.fidelityChoiceIndex !== CESAR_LOYALTY
                ) {
                    ids.add(element.Id);
                }
            }
        }
        return [...ids];
    }, [oneShop, shopsFidelityData, archivedFidelityFranchise]);

    return { dataAssociate, dataArchive };
}
